// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ec3f762c343e21294f0bf4553a0339347a473a90.chunk.js";
};